import { render } from "./PageItems.vue?vue&type=template&id=4e6820d6&scoped=true"
import script from "./PageItems.vue?vue&type=script&lang=js"
export * from "./PageItems.vue?vue&type=script&lang=js"

import "./PageItems.vue?vue&type=style&index=0&id=4e6820d6&scoped=true&lang=css"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6820d6"]])

export default __exports__